import { useCallback, useMemo } from "react"
import { CopyItemCell, tableHooks } from "components/Table"
import { RolesCell } from ".."
import { useNavigate, useParams } from "react-router-dom"
import { app } from "router/routes"
import { ReactComponent as LockIcon } from 'assets/icons/Lock.svg';
import { IconButton, SvgIcon } from "@mui/material"
import { useMutation } from "@tanstack/react-query"
import { toast } from "react-toastify"
import { toastConfig } from "config"
import { sendUserDetailsEmailFetch } from "store/middlewares/user.crud"
import { features } from "keys"
import { permissions } from "config/ability"

const useTeamTableColumns = () => {
    const navigate = useNavigate()
    const { affiliationID } = useParams()

    const editUser = useCallback(({ id }) => {
        navigate(`${app.affiliations}/${affiliationID}/staff/${id}`)
    }, [affiliationID])

    const editCell = tableHooks.useEditCell({
        action: editUser,
        feature: features.user_role,
        role: permissions.write
    })

    const { mutateAsync: sendUserDetailsEmail } = useMutation({
        mutationFn: sendUserDetailsEmailFetch,
        onSuccess: () => {
            toast('שלחנו את שם המשתמש והסיסמא למייל של המשתמש', toastConfig)
        },
        onError: () => {
            toast.error("ישנה בעייה בשליחת המייל למשתמש, אנא צור קשר אם הנהלת המערכת", toastConfig)
        }
    })

    const teamTableColumns = useMemo(() => [
        {
            accessorKey: 'id',
            header: "ID",
        },
        {
            accessorKey: 'custom_user.first_name',
            header: "שם פרטי",
        },
        {
            accessorKey: 'custom_user.last_name',
            header: "משפחה",
        },
        {
            accessorKey: 'custom_user.username',
            header: "שם משתמש",
        },
        {
            accessorKey: 'custom_user.initial_pass',
            header: "סיסמא",
            feature: features.user_password,
            role: permissions.read
        },
        {
            accessorKey: 'roles',
            header: "תפקיד",
            cell: RolesCell,
            enableSorting: false
        },
        {
            accessorKey: 'custom_user.tz',
            header: "תעודת זהות",
            enableSorting: false
        },
        {
            accessorKey: 'custom_user.email',
            header: "מייל",
            cell: CopyItemCell,
            meta: {
                tooltip: "כתובת המייל הועתקה בהצלחה"
            },
            enableSorting: false
        },
        {
            accessorKey: "send_email",
            header: "שליחת שם משתמש וסיסמא",
            cell: ({ row }) => {
                const data = row.original

                return (
                    <IconButton
                        label="Edit"
                        className="textPrimary"
                        onClick={() => sendUserDetailsEmail(data.id)}
                    >
                        <SvgIcon component={LockIcon} inheritViewBox />
                    </IconButton>
                );
            }
        },
        editCell
    ], [])

    return teamTableColumns
}

export default useTeamTableColumns